import axios from 'axios';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [],
    steps: [],
    skip : 0,
    take : 25,
    columns: [
            {
                table: "price_lists",
                direction : "ASC",
                direction_pos : 0,
                key : "name",
                label : "name",
                setable: false,
                class: "is-2",
                display : true
            },
            {
                table: "currencies",
                sortkey : "name",
                direction : "ASC",
                direction_pos : 0,
                key : "currency.name",
                label : "currency",
                display : true,
            },
            {
                table: "companies",
                sortkey : "name",
                direction : "ASC",
                direction_pos : 0,
                key : "company.name",
                label : "company",
                display : true
            },
        ],
    loaded : false,
    loadingMore: false,
    loading: false,
    allLoaded : false,
    addNew : false,
    workingOn: [],
    infinity: {
        active : false,
    },
    pagination : {
        currentPage: 1,
        totalPageCount: 1,
    },
    meat: {},
})

  // getters
  const getters = {
      isWorkingOn : (state) => (id) => {
          var index = state.workingOn.findIndex(id);
          if(index >= 0){
              return true;
          }else{
              return false;
          }
      }
  }

  // actions
  const actions = {
    async load({commit, state, rootState}, page = 1){
        commit("skip", (page - 1) * state.take);

        commit("isLoading", true);
        if(state.allLoaded == false){
            await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/price_lists", {params: {take: state.take, skip:state.skip, table_columns : state.columns}}).then((response) => {
                commit("setList", response.data.data);
                commit("pagination", _.get(response, "data.meta.pagination", {total: 0, take: state.take}))
                commit("isLoading", false);
            })
        }
        commit("isLoading", false);
    },
    async update({commit, state, rootState}, data){
        await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/price_lists/" + data.id, data).then(response => {
            commit("update", response.data.data);
        })
    },
    async store({commit, state, rootState}, data){
        await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/price_lists", data).then(response => {
            commit("unshift", response.data.data);
        })
    },
    async delete({commit, state, rootState}, data){
        await axios.delete(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/price_lists/" + data.id).then(response => {
            commit("removeId", response.data.deleted);
        })
    }
  }

  // mutations
  const mutations = {
      pagination(state, object){
        state.meta = object;
        if(state.skip <= 0){
            state.pagination.currentPage = 1;
        }else{
           state.pagination.currentPage = (state.skip / state.take) + 1;
        }
            state.pagination.totalPageCount = Math.ceil(state.meta.total / state.take);
            if(state.infinity.active == true && state.meta.total <= state.skip){
                state.allLoaded = true;
            }
      },
      skip(state, skip){
          state.skip = skip;
      },
      subLoading(state, mail){
          var index = state.workingOn.findIndex(item => item = mail.id);
          if(index >= 0){
              state.workingOn.splice(index, 1);
          }else{
              state.workingOn.push(mail.id);
          }
      },
      removeId(state, id){
          var index = state.list.findIndex(item => item.id == id);
          if(index >= 0){
              state.list.splice(index, 1);
          }
      },
      update(state, element){
          var index = state.list.findIndex(item => item.id == element.id);
          state.list[index] = element;
      },
      unshift(state, element){
          state.list.unshift(element);
      },
      setList(state, list){
          if(list == undefined || list.length <= 0){
            state.allLoaded = true;
          }
        if (state.infinity.active == true) {
            state.list.push(...list);
        } else {
            state.list = list;
        }
      },
      setSteps(state, list){
        if(list == undefined || list.length <= 0){
          state.allLoaded = true;
        }
        state.steps.push(...list);
    },
      increasePage(state){
          state.loadingMore = true;
          state.page++;
      },
      isLoading(state, status){
          state.loadingMore = status;
          state.loading = status;
      },
      updateColumn(state, column){
        var index = state.columns.findIndex(item => item.key == column.key)
        for(let i in state.columns){
            state.columns[i].direction_pos += 1;
        }
        if(index > -1){
            column.direction_pos = 0;
            state.columns[index] = column;
        }
    }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
